import React from "react";

import { ensureString } from "@intelligems/ig-utils";
import { styled } from "@mui/material";
import { NewButtonRoot } from "@src/QuantityButtonsView/components/NewButtonRoot";
import { QuantityButtonsWrapper } from "@src/QuantityButtonsView/components/QuantityButtonsWrapper";
import {
  Badge,
  ContentIconWrapper,
  QuantityButtonWidgetVariantWrapper,
  SectionTitle,
  SharedButtonContent,
  SharedColumnLayout,
  SharedRowLayout,
} from "@src/QuantityButtonsView/components/sharedComponents";

import { useQuantityButtonsContext } from "../context/QuantityButtonsContext";

export const QuantityButtonsWidgetClassic = () => {
  const { widget } = useQuantityButtonsContext();

  const renderFreeShippingLabelPlaceholder = widget.variables.buttons
    .filter((button) => !button.freeShipping?.hide)
    .some((button) => button.freeShipping?.freeShippingLabel);

  const renderFreeGiftLabelPlaceholder = widget.variables.buttons
    .filter((button) => !button.freeGift?.hide)
    .some((button) => button.freeGift?.freeGiftLabel);

  const renderLabelPlaceholder = widget.variables.buttons.some(
    (button) => button.label
  );

  return (
    <QuantityButtonWidgetVariantWrapper
      buttonVariant={"quantityButtonsWidgetClassic"}
    >
      {widget.variables?.sectionTitle ? <SectionTitle /> : null}

      <QuantityButtonsWrapper
        renderButton={({ button, selected, index }) => (
          <NewButtonRoot
            key={index}
            button={button}
            selected={selected}
            renderContent={({ button, newTotalPrice, totalComparePrice }) => (
              <div className={"ig-quantity-widget-root-wrapper"}>
                {button.badge && (
                  <Badge className={"ig-quantity-widget-badge"}>
                    {button.badge}
                  </Badge>
                )}
                <SharedButtonContent>
                  <ContentIconWrapper>
                    <RadioButton
                      className={"ig-quantity-radio-button"}
                      selected={selected}
                    />

                    {widget.styles.appearance.layout === "row" ? (
                      <SharedRowLayout
                        selected={selected}
                        renderFreeGiftLabelPlaceholder={
                          renderFreeGiftLabelPlaceholder
                        }
                        renderFreeShippingLabelPlaceholder={
                          renderFreeShippingLabelPlaceholder
                        }
                        renderLabelPlaceholder={renderLabelPlaceholder}
                        button={button}
                        newTotalPrice={newTotalPrice}
                        totalComparePrice={totalComparePrice}
                      />
                    ) : (
                      <SharedColumnLayout
                        selected={selected}
                        button={button}
                        newTotalPrice={newTotalPrice}
                        totalComparePrice={totalComparePrice}
                      />
                    )}
                  </ContentIconWrapper>
                </SharedButtonContent>
              </div>
            )}
          />
        )}
      />
    </QuantityButtonWidgetVariantWrapper>
  );
};

const RadioButton = styled("div")<{ selected: boolean }>(({ selected }) => {
  const { widget } = useQuantityButtonsContext();
  const { styles } = widget;

  return {
    width: "18px",
    height: "18px",
    borderRadius: "50%",
    border: `2px solid ${styles.backgroundColors.buttonBorderColor}`,
    backgroundColor: "transparent",
    position: "relative",
    flexShrink: 0,
    "&::after": selected
      ? {
          content: '""',
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "12px",
          height: "12px",
          borderRadius: "50%",
          backgroundColor: styles.backgroundColors.buttonBorderColor,
        }
      : {},
  };
});
